import { MachineForm } from "@/components/MachineForm";
import { Action } from "@/models/actions/Action";
import { ActionControls } from "@/models/actions/ActionControls";
import { Machine } from "@/models/Machine";
import { notification } from "antd";

export class EditMachineAction implements Action {
	constructor(private readonly machine?: Machine) {}

	getOptions() {
		return {
			width: "40vw",
			title: this.machine ? "Editar máquina" : "Adicionar máquina",
		};
	}

	render(controls: ActionControls) {
		return (
			<MachineForm
				machine={this.machine}
				onSubmitting={() => controls.setCloseable(false)}
				onSubmitted={(machine) => this.onSuccess(machine, controls)}
				onSubmissionFailed={(error) => this.onFailure(error, controls)}
			/>
		);
	}

	private onSuccess(_machine: Machine, controls: ActionControls) {
		controls.setCloseable(true);
		controls.close();

		notification.success({ message: "Máquina salva com sucesso!" });
	}

	private async onFailure(error: any, controls: ActionControls) {
		if (error?.response?.status === 406) {
			const errorMessage = await error?.response.json();
			controls.setCloseable(true);
			notification.error({ message: errorMessage.message });
			return;
		}
		controls.setCloseable(true);

		notification.error({ message: "Erro ao salvar máquina" });
	}
}
